import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    businessUnits: []
  },

  actions: {
    async getBusinessUnits ({ commit, state }, { firefighterId, params = {} } = {}) {
      const response = await http.get(`firefighters/${id(firefighterId)}/business-units`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetBusinessUnits ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.businessUnits = items
    }
  }
}
